import React, { Dispatch, SetStateAction } from 'react';
import { ICompanyResponse } from '../../../../../../../Interfaces/responseTypes';
import { ITableReserveForm } from '../../../../../../../Interfaces/formValue-interfaces';
import { VisitorPageContents } from '../../../../visitorPage';
import { ICartItem } from '../../../../../../../Interfaces/componentTypes';
import useByteFooter from './footer-hook';
import { CartIcon, ReserveIcon } from '../../../../../../../Components/IconComponents';
import styles from './footer.module.scss';

export interface IFooterProps {
  data: ICompanyResponse,
  contentType: VisitorPageContents,
  is_user: boolean;
  mainCart: [] | ICartItem[],
  isReserveForm: ITableReserveForm | null,
  setContentType: Dispatch<SetStateAction<VisitorPageContents>>,
  onOpenMainCartDialog: () => void,
  onOpenReserveDialog: () => void
}

const Footer: React.FC<IFooterProps> = (props) => {
  const { contentType, mainCart, is_user, isReserveForm, onOpenMainCartDialog, onOpenReserveDialog } = props;

  const nav = typeof navigator !== "undefined" ? navigator : undefined;

  const platform = (nav as any)?.platform || ""; // avoid TS warning safely
  const userAgent = nav?.userAgent || "";
  const maxTouchPoints = nav?.maxTouchPoints || 0;

  const isIOS =
    !!nav &&
    (
      /iPad|iPhone|iPod/.test(platform) ||
      (platform === "MacIntel" && maxTouchPoints > 1) ||
      (/Apple/i.test(userAgent) && /Mobile/i.test(userAgent)) ||
      /iPhone|iPad|iPod/.test(userAgent) // Additional check for userAgent
    ); 

  const isPWA =
    typeof window !== "undefined" &&
    (window.matchMedia('(display-mode: standalone)').matches ||
      (window.navigator as any).standalone === true ||
      window.matchMedia('(display-mode: fullscreen)').matches); // Include fullscreen mode

  const isIOSPWA = isIOS && isPWA;
  const footerStyle = is_user
    ? { padding: isIOSPWA ? "20px 15px 25px" : "20px 15px 5px" }
    : undefined;

  const cartBoxStyle = is_user ? { top: "-35px" } : undefined;

  const { footerNavItems } = useByteFooter(props);
  const ordersIndex = footerNavItems.findIndex(
    (item) => item.id === VisitorPageContents.MY_ORDERS
  );
  const leftNavs = ordersIndex > 0 ? footerNavItems.slice(0, ordersIndex) : footerNavItems;
  const middleNav = ordersIndex !== -1 ? footerNavItems[ordersIndex] : null;
  const rightNavs = ordersIndex !== -1 ? footerNavItems.slice(ordersIndex + 1) : [];

  return (
    <div className={styles.container} style={footerStyle}>
      {middleNav ? (
        <>
          <div className={`${styles.sideNav} ${styles.leftNav}`}>
            {leftNavs.map((nav) => (
              <div
                key={nav.id}
                className={contentType === nav.id ? styles.navItemChecked : styles.navItem}
                onClick={nav.onClick}
              >
                {nav.icon}
                <p>{nav.title}</p>
              </div>
            ))}
          </div>

          <div
            className={`${contentType === middleNav.id ? styles.navItemChecked : styles.navItem} ${styles.middleNav}`}
            onClick={middleNav.onClick}
          >
            {middleNav.icon}
            <p>{middleNav.title}</p>
          </div>

          <div className={`${styles.sideNav} ${styles.rightNav}`}>
            {rightNavs.map((nav) => (
              <div
                key={nav.id}
                className={contentType === nav.id ? styles.navItemChecked : styles.navItem}
                onClick={nav.onClick}
              >
                {nav.icon}
                <p>{nav.title}</p>
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className={styles.singleNavRow}>
          {footerNavItems.map((nav) => (
            <div
              key={nav.id}
              className={contentType === nav.id ? styles.navItemChecked : styles.navItem}
              onClick={nav.onClick}
            >
              {nav.icon}
              <p>{nav.title}</p>
            </div>
          ))}
        </div>
      )}
      <div
        style={cartBoxStyle}
        className={`${styles.cartBox} ${mainCart.length > 0 && styles.activeCart}`}
        onClick={isReserveForm ? onOpenReserveDialog : onOpenMainCartDialog}
      >
        {mainCart.length > 0 && <p>{mainCart.length}</p>}
        {isReserveForm ? (
          <ReserveIcon width={25} height={25} color={"white"} />
        ) : (
          <CartIcon width={25} height={25} color={"white"} />
        )}
      </div>
    </div>
  );
};

export default Footer
